import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./css/style.css";
import "./css/satoshi.css";
import { Provider } from "react-redux";
import { store } from "@services/StateManagement/Store";
import RealmSelection from "@common/RealmSelection";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { SetKeycloakRealm, initOptions } from "@services/KeyCloak/KeyCloak";
import { LOGIN_STATES } from "@constants/Enums";
import ResetStoredUserOnRouteChange from "@components/Providers/ResetStoredUserOnRouteChange";
import { UseAuthMainInitializer } from "./hooks/useAuthMainInitializer";

const Main = () => {
  const mainAuthInit = UseAuthMainInitializer();
  if (
    mainAuthInit.loginState == LOGIN_STATES.START ||
    mainAuthInit.loginState == LOGIN_STATES.LOGGING_OUT
  ) {
    return (
      <RealmSelection
        onSelectRealm={mainAuthInit.handleRealmSelection}
        onSelectAdminRealm={mainAuthInit.handleSelectAdminRealm}
        loading={mainAuthInit.loading}
        error={mainAuthInit.error}
        selectedRealm={mainAuthInit.realm}
      />
    );
  }

  return (
    <ReactKeycloakProvider
      authClient={SetKeycloakRealm(mainAuthInit.realm)}
      initOptions={initOptions}
      onEvent={mainAuthInit.handleKeycloakEvent}
    >
      <App />
    </ReactKeycloakProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  //<React.StrictMode>
  <Router>
    <Provider store={store}>
      <ResetStoredUserOnRouteChange />
      <Main />
    </Provider>
  </Router>,
  // </React.StrictMode>
);
